import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import jwtEncode from "jwt-encode";

import { AuthContext } from "../services/Context/Auth/context";
import User from "../services/db/user";

const Welcome = () => {
  const { handleLogin } = React.useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLn = async (e) => {
    e.preventDefault();
    try {
      const userData = await new User().authenticate(email, password);

      const SECRET = "my-frontend-secret";

      const exp = Math.floor(Date.now() / 1000) + 86400; // 24 hr

      const token = jwtEncode({ ...userData, exp }, SECRET);
      handleLogin(token);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <form onSubmit={handleLn}>
      <Grid container spacing={1} sx={{ height: "100vh" }}>
        {/* <CssBaseline /> */}
        <Grid
          container
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          xs={6}
          item
          sx={{ bgcolor: "#ffebee" }}
        >
          <img src="./assets/logo.png" width={600} />
        </Grid>
        <Grid
          item
          xs={6}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          sx={{ bgcolor: "#757575" }}
        >
          <Box
            display="flex"
            flexDirection="column"
            textAlign="center"
            alignItems="center"
            borderRadius={5}
            sx={{
              width: "600px",
              height: "600px",
              bgcolor: "#fafafa",
              py: "100px",
            }}
          >
            <Typography variant="h3">Welcome Admin</Typography>

            <TextField
              variant="outlined"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{ sx: { borderRadius: "50px" } }}
              sx={{ width: "450px", py: 2 }}
            />

            <TextField
              variant="outlined"
              placeholder="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{ sx: { borderRadius: "50px" } }}
              sx={{ width: "450px", py: 2 }}
            />

            <Button
              variant="contained"
              sx={{
                width: "450px",
                py: 2,
                backgroundColor: "#e91e63",
                borderRadius: "50px",
              }}
              type="submit"
            >
              Sign in
            </Button>
          </Box>
        </Grid>
      </Grid>
    </form>
  );
};

export default Welcome;
